"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedRefundCartItemResponseExceptRefund = exports.mockedRefundCartItemResponse = void 0;
const omit_util_1 = require("../../utils/omit.util");
const cart_item_1 = require("../cart-item");
const refund_1 = require("../refund");
exports.mockedRefundCartItemResponse = {
  id: 1,
  refund: refund_1.mockedRefundResponse,
  price: 100,
  quantity: 2,
  cartItemId: cart_item_1.mockedCartItemResponse.id
};
exports.mockedRefundCartItemResponseExceptRefund = omit_util_1.omitObject(exports.mockedRefundCartItemResponse, 'refund');